/**
 * Query parameter to specify which identity provider to redirect the user to for authentication.
 */
export const IDP_QUERY_PARAM = 'idp';
